// extracted by mini-css-extract-plugin
module.exports = {"round":"Icon_round__1NauJ"};